import { BrandsScreen } from 'app/features/brands/screens'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page() {
  return <BrandsScreen />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user
  const client = initializeApollo({ token: user?.token })

  // TODO: Add pagination so we can do SSR. Currently there's too much data
  // await client.query({
  //   query: brandsQuery.query,
  //   variables: {
  //     ...brandsQuery.defaultVariables,
  //   },
  // })

  return addApolloState(client, {
    props: {
      user: user || null,
    },
  })
})
